import themes from '@8x8/oxygen-theme'
import { THEMES } from '../constants'
import common from './common'

export default {
  ...common,
  _name: THEMES.DARK,
  _neo: themes.dark,
  background: '#2A3A4B',
  backgroundActiveMeetingOverlay: 'linear-gradient(270deg, #4687ED 43.13%, rgba(70, 135, 237, 0) 95%)',
  backgroundCopyInfo: '#2A3A4B',
  backgroundEventOverlay: 'linear-gradient(270deg, #666666 43.13%, rgba(102, 102, 102, 0) 95%)',
  backgroundHighlightedEventOverlay: 'linear-gradient(270deg, #F1F1F1 43.13%, rgba(241, 241, 241, 0) 95%)',
  backgroundInput: 'transparent',
  backgroundJoinOptionHint: 'rgba(49, 183, 106, 0.4)',
  backgroundListItemSelected: 'rgba(94, 109, 122, 0.2)',
  backgroundModal: '#1C2025',
  backgroundSalesforce: '#2A3A4B',
  backgroundSecondary: 'rgba(255, 255, 255, 0.2)',
  backgroundSelected: 'rgba(255, 255, 255, 0.8)',
  backgroundSidebarSecondary: 'rgba(0, 0, 0, 0.4)',
  backgroundViewJoinOptions: '#2A3A4B',
  backgroundWarning: '#f1ad33',
  borderColorInput: '#5E6D7A',
  boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.5)',
  boxShadowSalesforceSearchItem: 'inset 0px -1px 0px rgba(255, 255, 255, 0.15)',
  color: 'white',
  colorDelimiter: 'rgba(255, 255, 255, 0.1)',
  colorError: '#e12d2d',
  colorHighlight: 'white',
  colorIcon: '#a4b8d1',
  colorInput: 'white',
  colorLabel: '#A4B8D1',
  colorLink: '#278ADF',
  colorListItemIcon: '#a4b8d1',
  colorSecondary: 'rgba(255, 255, 255, 0.6)',
  colorSelected: '#1C2025',
  colorTertiary: 'white'
}
